import * as ng from 'angular';
import { TableHeaderItem } from '../domain/table-header-item';

export const TableHeader = {
    template: require('./table-header.html'),
    controller: class TableHeader {
        private items: Array<TableHeaderItem>;
        private onSort: Function;

        private selectedColumn: number;
        private sortDirection: number; // 1 - ascending, -1 - descending

        constructor() {
            this.sortDirection = 1;
        }

        sort(column: number) {
            const element = ng.element('th i');
            if (this.selectedColumn > -1) {
                element[this.selectedColumn].className = 'fa fa-sort';
            }
            this.sortDirection = this.selectedColumn === column ? this.sortDirection * -1 : 1;
            element[column].className = this.sortDirection === 1 ? 'fa fa-sort-asc' : 'fa fa-sort-desc';
            this.selectedColumn = column;
            this.onSort({
                sortField: this.items[column].key,
                sortDirection: this.sortDirection
            });
        }
    },
    bindings: {
        items: '<',
        onSort: '&'
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/table-component/table-header/table-header.ts